import { render, staticRenderFns } from "./notice.vue?vue&type=template&id=0d6a4747&scoped=true&"
var script = {}
import style0 from "./notice.vue?vue&type=style&index=0&id=0d6a4747&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6a4747",
  null
  
)

export default component.exports